import React from "react";
import "./navbar.scss";
import logo from "../../../assets/logo.png";

const PPCNavbar = () => {
  return (
    <header className="ppc-navbar">
      <div className="navbar-container">

        {/* Logo */}
        <div className="ppc-logo">
          <a href="#home">
            <img src={logo} alt="Dental Clinic Logo" />
          </a>
        </div>

        {/* Navigation */}
        <nav className="ppc-nav">
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#dentist">Dentist</a>
          <a href="#gallery">Gallery</a>
          <a href="#testimonials">Testimonials</a>
          <a href="#contact">Contact</a>
        </nav>

        {/* CTA */}
        <div className="ppc-cta">
         
          <a href="#contact" className="ppc-btn">
            Book Appointment
          </a>
        </div>

      </div>
    </header>
  );
};

export default PPCNavbar;
